import styled from 'styled-components';

export const SearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  .ant-input {
    border-color: #585759 !important;
    position: absolute;
    left: 5px;
    top: 0;
    height: 29px;
    width: 300px;
  }
  .ant-input-affix-wrapper {
    height: 32px;
    position: relative;
  }
`;

export const Title = styled.h3`
  font-size: 1.25em;
  text-align: left;
  margin: 0.4em;
`;
